const styles = (theme) => ({
  link: {
    padding: '0px',
    minWidth: '0px',
    margin: theme.spacing(1, 0),
  },
});

export default styles;
